import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { useField } from 'react-final-form';
import { FileField } from '@/components/functional/Form/FileField';
import { Text } from '@/components/ui/Typography/Body/Text';
import { ACCEPT_IMAGE_MIME_TYPE } from '@/utils/validate/conditions';
import { validateCardUpload } from '@/utils/validate/resources/card/card';
/**
 * 名刺登録用 ファイル選択フォーム
 * @param props
 * @returns
 */
export const CardFileField = (props) => {
    const { className = '', loading, name } = props;
    const { input: { value }, } = useField(name);
    const fileName = useMemo(() => { var _a, _b; return ((_b = (_a = value === null || value === void 0 ? void 0 : value.item) === null || _a === void 0 ? void 0 : _a.call(value, 0)) === null || _b === void 0 ? void 0 : _b.name) || ''; }, [value]);
    return (_jsxs("div", Object.assign({ className: clsx('flex flex-col gap-y-8', className) }, { children: [_jsx(FileField, { accept: ACCEPT_IMAGE_MIME_TYPE, isFull: true, isFullRounded: true, loading: loading, name: name, size: 'md', validate: validateCardUpload }), fileName && (_jsx(Text, Object.assign({ className: 'text-center', size: 'sm' }, { children: fileName })))] })));
};
